// Shard 2 — page-local translations for:
//   src/pages/UnifiedCommand.jsx
//   src/pages/AIAssurance.jsx
//   src/pages/CrowdIntelligence.jsx
//
// Note: a handful of keys below (Ramkund Ghat, Panchvati, Trimbakeshwar,
// Nashik Road Stn, Kalaram Temple, Gangapur Camp, pilgrims, Active, Live,
// In Progress, Critical, High, Med, Pending, Closed, Approved, Low, Status,
// Department, Risk Level, Critical Zones, Resolution Rate, CRITICAL, HIGH,
// MED) already exist in dictionary.js's COMPONENT_STRINGS. They are
// intentionally repeated here with the SAME Marathi value so this shard's
// merge (which loads after COMPONENT_STRINGS) doesn't shadow it with a
// different translation elsewhere in the app.
const shard2 = {
  // ── shared / reused from COMPONENT_STRINGS (kept identical) ──
  "Active": "सक्रिय",
  "Live": "थेट",
  "In Progress": "प्रगतीपथावर",
  "Critical": "गंभीर",
  "High": "उच्च",
  "Med": "मध्यम",
  "Pending": "प्रलंबित",
  "Closed": "बंद",
  "Approved": "मंजूर",
  "Low": "कमी",
  "Status": "स्थिती",
  "Department": "विभाग",
  "Risk Level": "जोखीम पातळी",
  "Critical Zones": "गंभीर झोन",
  "Resolution Rate": "निराकरण दर",
  "CRITICAL": "गंभीर",
  "HIGH": "उच्च",
  "MED": "मध्यम",
  "Ramkund Ghat": "रामकुंड घाट",
  "Panchvati": "पंचवटी",
  "Trimbakeshwar": "त्र्यंबकेश्वर",
  "Nashik Road Stn": "नाशिक रोड स्थानक",
  "Kalaram Temple": "काळाराम मंदिर",
  "Gangapur Camp": "गंगापूर कॅम्प",
  "pilgrims": "यात्रेकरू",

  // extra uppercase status words not already central
  "MODERATE": "मध्यम",
  "NORMAL": "सामान्य",
  "WATCH": "सतर्कता",
  "LOW": "कमी",
  "Maha Kumbh AI": "महा कुंभ एआय",

  // ============================================================
  // ModelTrust.jsx
  // ============================================================
  "AI Trust Centre": "एआय विश्वास केंद्र",
  "Every AI confidence score shown across the platform, paired with the issuing model's real track record — the answer to 'how good has this model actually been'":
    "प्लॅटफॉर्मवर दाखवलेला प्रत्येक एआय विश्वासार्हता गुण, तो देणाऱ्या मॉडेलच्या खऱ्या कामगिरीसह जोडलेला — 'हे मॉडेल प्रत्यक्षात किती चांगले आहे' या प्रश्नाचे उत्तर",
  "Models Monitored": "निरीक्षणाधीन मॉडेल्स",
  "Avg Model Accuracy": "सरासरी मॉडेल अचूकता",
  "Needing Attention": "लक्ष आवश्यक",
  "Total AI Reviews": "एकूण एआय पुनरावलोकने",
  "Live Confidence, Paired With Track Record": "थेट विश्वासार्हता, कामगिरीसह जोडलेली",
  "Every item in today's human review queue, next to how right its model has actually been":
    "आजच्या मानवी पुनरावलोकन रांगेतील प्रत्येक बाब, त्या मॉडेलची प्रत्यक्ष अचूकता किती आहे यासह",
  "this time": "यावेळी",
  "lifetime accuracy": "एकूण अचूकता",
  "no track record yet": "अद्याप कामगिरी नोंद नाही",
  "Model Trust Ledger": "मॉडेल विश्वास नोंदवही",
  "Every production model, its track record, and which page's numbers it actually powers":
    "प्रत्येक कार्यरत मॉडेल, त्याची कामगिरी, आणि ते प्रत्यक्षात कोणत्या पानावरील आकडे चालवते",
  "Model": "मॉडेल",
  "Drift": "ड्रिफ्ट",
  "Bias": "पूर्वग्रह",
  "Powers": "चालवते",
  "Today's Crowd Forecast Accuracy": "आजची गर्दी अंदाज अचूकता",
  "Computed from the same actual-vs-predicted numbers shown on Crowd Risk Engine and War Room — gathered here as a running track record":
    "गर्दी जोखीम इंजिन आणि वॉर रूमवर दाखवलेल्या प्रत्यक्ष वि. अंदाजित आकड्यांवरून मोजलेली — येथे सातत्यपूर्ण कामगिरी नोंद म्हणून एकत्रित",
  "accurate across the": "अचूक, एकूण",
  "hours checked so far today": "आज आतापर्यंत तपासलेल्या तासांपैकी",
  "Every hour where an actual pilgrim count has come in is compared against what the model predicted for that same hour, before the count was known. This is the same forecast that drives the risk badges on Crowd Risk Engine and War Room — shown here on its own, as a number that can be checked against reality, rather than a confidence score with nowhere to be verified.":
    "प्रत्यक्ष यात्रेकरू संख्या आलेल्या प्रत्येक तासाची तुलना, ती संख्या कळण्यापूर्वी मॉडेलने त्याच तासासाठी काय अंदाज वर्तवला होता याच्याशी केली जाते. गर्दी जोखीम इंजिन आणि वॉर रूमवरील धोका बॅज हाच अंदाज वापरतात — येथे तो स्वतंत्रपणे, पडताळता येणारा आकडा म्हणून दाखवला आहे, पडताळणीची जागा नसलेला केवळ विश्वासार्हता गुण म्हणून नव्हे.",
  "See the longer-run track record across past Kumbh events": "मागील कुंभ कार्यक्रमांमधील दीर्घकालीन कामगिरी नोंद पहा",

  // Page-name link chips in the Model Trust Ledger. "Missing Persons" and
  // "AI Stack Assurance" already have entries in shard1.js (from that page's
  // own translation pass) and are deliberately not repeated here — shard2
  // loads after shard1, so redefining them with a different Marathi reading
  // would silently override shard1's version everywhere else it's used.
  "Crowd Risk Engine": "गर्दी जोखीम इंजिन",
  "Unified Command": "एकीकृत कमांड",
  "War Room": "वॉर रूम",
  "Field Copilot": "फील्ड कोपायलट",
  "Health & Epidemic": "आरोग्य व साथरोग",
  "Mobility Intelligence": "वाहतूक इंटेलिजन्स",
  "Service Stress": "सेवा ताण",
  "Pilgrim Guidance": "यात्रेकरू मार्गदर्शन",
  "Showing": "दाखवत आहे",
  "of": "पैकी",
  "open incidents — full queue includes lower-priority items not requiring live command attention":
    "खुल्या घटना — संपूर्ण यादीत कमी-प्राधान्याच्या बाबींचाही समावेश आहे ज्यांना थेट कमांड लक्ष देण्याची गरज नाही",
  "Full duty roster — live location, task and status for every officer":
    "संपूर्ण कर्तव्य यादी — प्रत्येक अधिकाऱ्याचे थेट स्थान, कार्य आणि स्थिती",

  // ============================================================
  // WarRoom.jsx (merged Unified Command + War Room)
  // ============================================================
  "Unified Command Intelligence Dashboard": "एकीकृत कमांड बुद्धिमत्ता डॅशबोर्ड",
  "State-wide command overview · all agencies · zone-level risk · live incident management · officer board · SLA tracking · peak-snana analytics":
    "राज्यव्यापी कमांड आढावा · सर्व यंत्रणा · झोन-स्तरीय जोखीम · थेट घटना व्यवस्थापन · अधिकारी फलक · एसएलए मागोवा · पीक-स्नान विश्लेषण",
  "State-wide unified command · all agencies · zone-level risk · live incident management · decision approval queue · cross-agency requests · SITREP · escalation pipeline · Shahi Snan planning · responsibility matrix · command authority chain · VIP coordination · audit trail · SLA analytics":
    "राज्यव्यापी एकीकृत कमांड · सर्व यंत्रणा · झोन-स्तरीय जोखीम · थेट घटना व्यवस्थापन · निर्णय मंजुरी रांग · आंतर-संस्था विनंत्या · सिटरेप · तीव्रता प्रक्रिया · शाही स्नान नियोजन · जबाबदारी मॅट्रिक्स · कमांड अधिकार साखळी · व्हीआयपी समन्वय · लेखापरीक्षण नोंद · एसएलए विश्लेषण",
  "18 ACTIVE": "18 सक्रिय",

  "Active Incidents": "सक्रिय घटना",
  "Escalations": "वाढीव प्रकरणे",
  "Resolved Today": "आज निकाली",
  "Avg Response": "सरासरी प्रतिसाद",
  "Units Deployed": "तैनात तुकड्या",
  "SLA at Risk": "एसएलए धोक्यात",

  "LIVE SITREP — 14:33 IST": "थेट सद्यस्थिती अहवाल — 14:33 IST",
  "Simhastha 2027 · Day 3 Operations · Maha Kumbh AI Command Centre, Nashik": "सिंहस्थ 2027 · दिवस 3 कार्यवाही · महा कुंभ एआय कमांड सेंटर, नाशिक",
  "6,84,210 pilgrims active across 6 zones · Crowd risk 5.8/10 · 18 incidents open, 57 resolved today · All 7 agencies operational · Next Shahi Snan T–18 hours":
    "6,84,210 यात्रेकरू 6 झोनमध्ये सक्रिय · गर्दी जोखीम 5.8/10 · 18 घटना खुल्या, आज 57 निकाली · सर्व 7 यंत्रणा कार्यरत · पुढील शाही स्नान T–18 तास",
  "Crowd Risk": "गर्दी जोखीम",
  "AI Uptime": "एआय कार्यरत वेळ",
  "SLA Met": "एसएलए पूर्तता",

  "Multi-Agency Command Map": "बहु-यंत्रणा कमांड नकाशा",
  "Refresh": "रिफ्रेश करा",

  "All": "सर्व",
  "Escalated": "वाढवलेले",
  "Responding": "प्रतिसाद देत आहे",
  "Monitoring": "निरीक्षणाधीन",
  "Responded": "प्रतिसाद दिला",
  "elapsed": "झाले",
  "Done": "पूर्ण",
  "Assigned Units": "नियुक्त तुकड्या",
  "Action Log": "कृती नोंद",

  "Crowd surge density >9/m²": "गर्दीची घनता वाढ >9/m²",
  "Water tanker not arrived": "पाण्याचा टँकर पोहोचला नाही",
  "Ambulance access blocked": "रुग्णवाहिका मार्ग अडवला",
  "Shelter overload Camp 3": "निवारा अतिभार कॅम्प 3",
  "Missing child — Panchvati Sec7": "बेपत्ता मूल — पंचवटी सेक्टर 7",
  "Heatstroke cluster — Zone D": "उष्माघात समूह — झोन D",

  "Ramkund Ghat, Entry 2": "रामकुंड घाट, प्रवेशद्वार 2",
  "Panchvati Water Point 8": "पंचवटी जलकेंद्र 8",
  "Camp Beta, Trimbak Rd": "कॅम्प बीटा, त्र्यंबक रोड",
  "Nashik Road Camp 3": "नाशिक रोड कॅम्प 3",
  "Panchvati, Sector 7": "पंचवटी, सेक्टर 7",
  "Godavari Zone D": "गोदावरी झोन D",

  "Approved crowd diversion to Entry 4": "प्रवेशद्वार 4 कडे गर्दी वळवण्यास मंजुरी",
  "Barricading activated — Entry 2 restricted": "बॅरिकेडिंग सक्रिय — प्रवेशद्वार 2 प्रतिबंधित",
  "Density alert escalated — confidence 91%": "घनता सूचना वाढवली — विश्वासार्हता 91%",
  "Megaphone announcement for crowd movement": "गर्दी हालचालीसाठी ध्वनिक्षेपक घोषणा",
  "Logged tanker delay — ETA 15:15": "टँकर विलंब नोंदवला — अंदाजित वेळ 15:15",
  "Replacement tanker TK-12 dispatched": "बदली टँकर TK-12 रवाना",
  "Auto-alert raised — 91% capacity breach": "स्वयं-सूचना जारी — 91% क्षमता ओलांडली",
  "Police escort authorised — route cleared": "पोलीस एस्कॉर्ट मंजूर — मार्ग मोकळा",
  "Escalated to Health Command for priority clearance": "प्राधान्य मंजुरीसाठी आरोग्य कमांडकडे वाढवले",
  "Route blockage detected — 3 alternate routes suggested": "मार्ग अडथळा आढळला — 3 पर्यायी मार्ग सुचवले",
  "Camp Delta activation in progress — ETA 16:00": "कॅम्प डेल्टा सक्रियकरण सुरू — अंदाजित वेळ 16:00",
  "Overload logged — 94% threshold crossed": "ओव्हरलोड नोंदवला — 94% मर्यादा ओलांडली",
  "Case MP-1185 registered — search ongoing": "प्रकरण MP-1185 नोंदवले — शोध सुरू",
  "CCTV facial recognition search initiated (DPDP consent obtained)": "सीसीटीव्ही चेहरा ओळख शोध सुरू (DPDP संमती प्राप्त)",
  "All 6 patients stabilised — incident resolved": "सर्व 6 रुग्ण स्थिर — घटना निकाली",
  "Emergency response dispatched — Zone D": "आपत्कालीन प्रतिसाद पथक रवाना — झोन D",
  "Heatstroke cluster pattern detected — confidence 88%": "उष्माघात समूह नमुना आढळला — विश्वासार्हता 88%",

  "Crowd density exceeded 9.2 persons/m² at Ramkund Ghat Entry 2. AI Crowd Engine flagged risk at 09:1 level. Police mobilised for crowd diversion to Entry 4.":
    "रामकुंड घाट प्रवेशद्वार 2 येथे गर्दीची घनता 9.2 व्यक्ती/m² ओलांडली. एआय क्राउड इंजिनने जोखीम पातळी 09:1 वर नोंदवली. प्रवेशद्वार 4 कडे गर्दी वळवण्यासाठी पोलीस तैनात.",
  "Water tanker TK-08 failed to arrive at Panchvati Water Point 8. Supply exhausted. NMC logistics contacted for emergency replacement tanker.":
    "पाण्याचा टँकर TK-08 पंचवटी जलकेंद्र 8 येथे पोहोचला नाही. पुरवठा संपला. आपत्कालीन बदली टँकरसाठी NMC लॉजिस्टिक्सशी संपर्क साधला.",
  "Ambulance AM-03 access route blocked by crowd at Camp Beta, Trimbak Road. Patient with heatstroke awaiting evacuation. Police escort requested.":
    "रुग्णवाहिका AM-03 चा मार्ग कॅम्प बीटा, त्र्यंबक रोड येथे गर्दीमुळे अडवला. उष्माघात झालेला रुग्ण स्थलांतराच्या प्रतीक्षेत. पोलीस एस्कॉर्टची विनंती.",
  "Nashik Road Camp 3 shelter at 94% capacity. 1,840 persons sheltered. Revenue Dept requested to open overflow Camp Delta for additional 500 persons.":
    "नाशिक रोड कॅम्प 3 निवारा 94% क्षमतेवर. 1,840 व्यक्तींना आश्रय. अतिरिक्त 500 व्यक्तींसाठी ओव्हरफ्लो कॅम्प डेल्टा उघडण्याची महसूल विभागाला विनंती.",
  "8-year-old child separated from parents at Panchvati Sector 7. Description registered. AI facial recognition search initiated (with consent). Police teams deployed.":
    "पंचवटी सेक्टर 7 येथे 8 वर्षांचे मूल पालकांपासून विभक्त झाले. वर्णन नोंदवले. एआय चेहरा ओळख शोध सुरू (संमतीने). पोलीस पथके तैनात.",
  "Cluster of 6 heatstroke cases reported in Godavari Zone D. Medical team dispatched. All patients stabilised and shifted to Camp Alpha.":
    "गोदावरी झोन D मध्ये 6 उष्माघाताच्या घटनांची नोंद. वैद्यकीय पथक रवाना. सर्व रुग्ण स्थिर करून कॅम्प अल्फा येथे हलवले.",

  "Zone Risk Matrix": "झोन जोखीम मॅट्रिक्स",
  "Real-time crowd density, risk level, incident count and unit deployment per zone": "प्रत्येक झोनमधील रिअल-टाइम गर्दी घनता, जोखीम पातळी, घटना संख्या आणि तुकडी तैनाती",
  "Zone": "झोन",
  "Pilgrims": "यात्रेकरू",
  "Density / m²": "घनता / m²",
  "Crowd Trend": "गर्दी कल",
  "Open Incidents": "खुल्या घटना",
  "Route Status": "मार्ग स्थिती",

  "rising": "वाढते",
  "stable": "स्थिर",
  "falling": "घटते",

  "Route Saturation Monitor": "मार्ग संपृक्तता मॉनिटर",
  "Current load per major entry/exit corridor": "प्रत्येक प्रमुख प्रवेश/निर्गम मार्गावरील सद्य भार",
  "Ramkund Ghat — Main Entry": "रामकुंड घाट — मुख्य प्रवेशद्वार",
  "Panchvati — Godavari Bridge": "पंचवटी — गोदावरी पूल",
  "Trimbakeshwar Temple Gate": "त्र्यंबकेश्वर मंदिर प्रवेशद्वार",
  "Nashik Road — Bus Terminal": "नाशिक रोड — बस टर्मिनल",
  "Kalaram Temple Corridor": "काळाराम मंदिर मार्गिका",
  "Gangapur Camp Zone": "गंगापूर कॅम्प झोन",
  "Overload — crowd diversion recommended": "ओव्हरलोड — गर्दी वळवण्याची शिफारस",

  "Live Feeds": "थेट फीड",
  "Alert Feed": "इशारा फीड",
  "Command Log": "कमांड नोंद",

  "Crowd surge at Ramkund Ghat — Entry 2": "रामकुंड घाट येथे गर्दी वाढ — प्रवेशद्वार 2",
  "Water station #8 at 91% capacity — Panchvati": "जल केंद्र #8 91% क्षमतेवर — पंचवटी",
  "Shuttle SR-04 delayed 22 min — Trimbakeshwar": "शटल SR-04 22 मिनिटे विलंबित — त्र्यंबकेश्वर",
  "Medical emergency — heatstroke Zone C Godavari": "वैद्यकीय आणीबाणी — उष्माघात झोन C गोदावरी",
  "Missing child reported at Panchvati Sector 7": "पंचवटी सेक्टर 7 येथे मूल बेपत्ता नोंदवले",
  "AI duplicate alert suppressed — Kalaram Zone": "एआय डुप्लिकेट सूचना दाबली — काळाराम झोन",
  "Shelter capacity 94% — Nashik Road Camp 3": "निवारा क्षमता 94% — नाशिक रोड कॅम्प 3",
  "Missing person resolved — ID #MP-1182": "बेपत्ता व्यक्ती सापडली — ओळख क्र. #MP-1182",
  "Fire alert suppressed (false positive) — Trimbak": "आग सूचना दाबली (खोटा इशारा) — त्र्यंबक",
  "New pilgrim guidance broadcast — Marathi/Hindi": "नवीन यात्रेकरू मार्गदर्शन प्रसारण — मराठी/हिंदी",

  "Auto-Closed": "स्वयं-बंद",
  "Validated": "सत्यापित",
  "Published": "प्रकाशित",

  "DCP Nashik approved crowd diversion — Ramkund Entry 2": "DCP नाशिक यांनी गर्दी वळवण्यास मंजुरी दिली — रामकुंड प्रवेशद्वार 2",
  "CMO reviewed heatstroke flag — Zone D, AI confidence 78%": "CMO ने उष्माघात सूचनेचे पुनरावलोकन केले — झोन D, एआय विश्वासार्हता 78%",
  "Missing child MP-1185 registered — Panchvati Sector 7": "बेपत्ता मूल MP-1185 नोंदवले — पंचवटी सेक्टर 7",
  "AI duplicate fire alert suppressed — Trimbak Zone A": "एआय डुप्लिकेट आग सूचना दाबली — त्र्यंबक झोन A",
  "Missing person MP-1182 located and reunited": "बेपत्ता व्यक्ती MP-1182 सापडली आणि कुटुंबाशी भेट झाली",
  "Extra MSRTC buses deployed — Nashik Road → Ramkund": "अतिरिक्त MSRTC बस तैनात — नाशिक रोड → रामकुंड",
  "Shelter Camp 3 at 94% — escalated to Revenue Dept": "निवारा कॅम्प 3 94% वर — महसूल विभागाकडे वाढवले",
  "Godavari Bridge congestion cleared — Police escort": "गोदावरी पूल वाहतूक कोंडी दूर — पोलीस बंदोबस्तात",
  "Public advisory broadcast — Marathi/Hindi — 82K reach": "सार्वजनिक सूचना प्रसारण — मराठी/हिंदी — 82K पोहोच",

  "Total": "एकूण",
  "Resolved": "निकाली",
  "Volunteers": "स्वयंसेवक",

  "Field Officer Board": "फील्ड अधिकारी फलक",
  "Live officer location, task and status": "थेट अधिकारी स्थान, कार्य आणि स्थिती",
  "Trimbak Rd Camp": "त्र्यंबक रोड कॅम्प",
  "Panchvati Zone": "पंचवटी झोन",
  "Crowd Control": "गर्दी नियंत्रण",
  "Missing Person Search": "बेपत्ता व्यक्ती शोध",
  "Entry Gate Mgmt": "प्रवेशद्वार व्यवस्थापन",
  "Ambulance Coord": "रुग्णवाहिका समन्वय",
  "Water Supply": "पाणीपुरवठा",
  "Transport Coord": "वाहतूक समन्वय",
  "On Duty": "कर्तव्यावर",
  "Emergency": "आणीबाणी",

  "Agency Task Coordination": "यंत्रणा कार्य समन्वय",
  "Task completion and SLA status per agency": "प्रत्येक यंत्रणेची कार्य पूर्तता आणि एसएलए स्थिती",
  "SLA breach": "एसएलए उल्लंघन",
  "done": "पूर्ण",
  "pending": "प्रलंबित",

  "Multi-Agency Operational Status": "बहु-यंत्रणा कार्यान्वयन स्थिती",
  "Live deployment, alerts and resolution rate per government department": "प्रत्येक सरकारी विभागाची थेट तैनाती, सूचना आणि निराकरण दर",
  "Deployed / Total": "तैनात / एकूण",
  "Deployment %": "तैनाती %",
  "Open Alerts": "खुल्या सूचना",

  "Peak Snana Analytics — Crowd Flow Prediction": "पीक स्नान विश्लेषण — गर्दी प्रवाह अंदाज",
  "Actual vs predicted pilgrim count · risk index · today's full-day forecast": "प्रत्यक्ष वि. अंदाजित यात्रेकरू संख्या · जोखीम निर्देशांक · आजचा संपूर्ण दिवसाचा अंदाज",
  "Actual": "प्रत्यक्ष",
  "Predicted": "अंदाजित",
  "Risk Index": "जोखीम निर्देशांक",
  "Peak day estimate": "पीक दिवस अंदाज",
  "Predicted peak hour": "अंदाजित पीक तास",
  "Peak risk index": "पीक जोखीम निर्देशांक",

  // ============================================================
  // AIAssurance.jsx
  // ============================================================
  "AI Stack Assurance Layer": "एआय स्टॅक हमी स्तर",
  "AI confidence scoring · false-positive analytics · human review queue · model health monitoring · drift detection · explainability engine":
    "एआय विश्वासार्हता गुणांकन · खोटे-सकारात्मक विश्लेषण · मानवी पुनरावलोकन रांग · मॉडेल आरोग्य निरीक्षण · ड्रिफ्ट शोध · स्पष्टीकरण इंजिन",

  "Overall Accuracy": "एकूण अचूकता",
  "False Positive Rate": "खोटे-सकारात्मक दर",
  "Human Reviewed": "मानवी पुनरावलोकन झालेले",
  "Pending Review": "प्रलंबित पुनरावलोकन",

  "AI-Assisted Governance — Not Autonomous Governance": "एआय-सहाय्यित प्रशासन — स्वायत्त प्रशासन नाही",
  "Every Maha Kumbh AI alert passes through a 3-stage validation pipeline:": "प्रत्येक महा कुंभ एआय सूचना 3-टप्प्यांच्या पडताळणी प्रक्रियेतून जाते:",
  "(1) Model Confidence Score": "(1) मॉडेल विश्वासार्हता गुण",
  "(2) Duplicate / False-positive Detection": "(2) डुप्लिकेट / खोटे-सकारात्मक शोध",
  "(3) Human Review & Approval": "(3) मानवी पुनरावलोकन आणि मंजुरी",
  "No enforcement action is taken from AI output alone. Human-in-loop is mandatory for all HIGH and CRITICAL alerts.":
    "एकट्या एआय निष्कर्षावरून कोणतीही अंमलबजावणी कारवाई केली जात नाही. सर्व उच्च आणि गंभीर सूचनांसाठी मानवी सहभाग अनिवार्य आहे.",
  "Human-in-Loop Mandatory": "मानवी सहभाग अनिवार्य",
  "Explainability Engine Active": "स्पष्टीकरण इंजिन सक्रिय",
  "No Autonomous Enforcement": "कोणतीही स्वायत्त अंमलबजावणी नाही",
  "DPDP 2023 Aligned": "DPDP 2023 अनुरूप",
  "Bias Monitoring": "पूर्वग्रह निरीक्षण",
  "Audit Trail Active": "लेखापरीक्षण मागोवा सक्रिय",

  "Model Accuracy": "मॉडेल अचूकता",
  "Human Validation": "मानवी पडताळणी",
  "Confidence Score": "विश्वासार्हता गुण",
  "FP Filter (inv.)": "FP फिल्टर (व्यस्त)",

  "Alert Validation Timeline — Today": "सूचना पडताळणी टाइमलाइन — आज",
  "Hourly: total AI alerts · validated · false positives · duplicates suppressed": "प्रति तास: एकूण एआय सूचना · पडताळलेल्या · खोट्या-सकारात्मक · दाबलेल्या डुप्लिकेट",
  "Total Alerts": "एकूण सूचना",
  "Validated": "सत्यापित",
  "False Positive": "खोटे-सकारात्मक",
  "Duplicates": "डुप्लिकेट",

  "AI Model Health Dashboard": "एआय मॉडेल आरोग्य डॅशबोर्ड",
  "Per-model accuracy, data drift, bias level and status": "प्रत्येक मॉडेलची अचूकता, डेटा ड्रिफ्ट, पूर्वग्रह पातळी आणि स्थिती",
  "Model Name": "मॉडेलचे नाव",
  "Accuracy": "अचूकता",
  "Drift Score": "ड्रिफ्ट गुण",
  "Bias Level": "पूर्वग्रह पातळी",
  "Reviews": "पुनरावलोकने",

  "Crowd Density CNN": "गर्दी घनता CNN",
  "Stampede Risk LSTM": "चेंगराचेंगरी जोखीम LSTM",
  "Missing Person Match": "बेपत्ता व्यक्ती जुळणी",
  "Alert Dedup Engine": "सूचना डिडुप इंजिन",
  "Heatstroke Predictor": "उष्माघात अंदाजक",
  "Transport Surge Forecast": "वाहतूक वाढ अंदाज",
  "Service Load Predictor": "सेवा भार अंदाजक",

  "Medium": "मध्यम",
  "Healthy": "निरोगी",
  "Alert": "इशारा",

  "Human Review Queue": "मानवी पुनरावलोकन रांग",
  "AI alerts requiring human validation — confidence threshold <85%": "मानवी पडताळणी आवश्यक असलेल्या एआय सूचना — विश्वासार्हता मर्यादा <85%",

  "Crowd surge AI flag — Entry 4 Ramkund": "गर्दी वाढ एआय सूचना — प्रवेशद्वार 4 रामकुंड",
  "Missing person face match #MP-1185": "बेपत्ता व्यक्ती चेहरा जुळणी #MP-1185",
  "Heatstroke cluster prediction Zone D": "उष्माघात समूह अंदाज झोन D",
  "Transport surge — Nashik Road 14:00–16:00": "वाहतूक वाढ — नाशिक रोड 14:00–16:00",
  "Shelter overload prediction — Camp 3": "निवारा ओव्हरलोड अंदाज — कॅम्प 3",
  "Fire alarm — possible false positive": "आग अलार्म — संभाव्य खोटा इशारा",

  "Reviewing": "पुनरावलोकनाधीन",
  "Rejected": "नाकारले",
  "Transport Surge": "वाहतूक वाढ",
  "Service Load": "सेवा भार",

  "FP Rate": "FP दर",

  "Alert Source Traceability": "सूचना स्रोत मागोवा",
  "Origin of AI-generated alerts by sensor / data source type": "सेन्सर / डेटा स्रोत प्रकारानुसार एआय-निर्मित सूचनांचे मूळ",
  "CCTV Camera Network": "सीसीटीव्ही कॅमेरा नेटवर्क",
  "Drone Thermal Imagery": "ड्रोन थर्मल इमेजरी",
  "Crowd Density Sensor Grid": "गर्दी घनता सेन्सर ग्रिड",
  "Police Mobile Reports": "पोलीस मोबाइल अहवाल",
  "Health Wearable Data": "आरोग्य परिधान करण्यायोग्य डेटा",
  "Transport IOT Sensors": "वाहतूक IOT सेन्सर",

  // ============================================================
  // CrowdIntelligence.jsx
  // ============================================================
  "Predictive Crowd Risk Engine": "पूर्वानुमानित गर्दी जोखीम इंजिन",
  "360° crowd intelligence · density · velocity · pressure · bottleneck AI · gate flow · 4-hour forecast · stampede risk · intervention recommendations":
    "360° गर्दी बुद्धिमत्ता · घनता · वेग · दाब · अडथळा एआय · प्रवेशद्वार प्रवाह · 4-तास अंदाज · चेंगराचेंगरी जोखीम · हस्तक्षेप शिफारसी",
  "RISK: 5.8/10": "जोखीम: 5.8/10",

  "Current Pilgrims": "सद्य यात्रेकरू",
  "Crowd Risk Index": "गर्दी जोखीम निर्देशांक",
  "Peak Estimate": "पीक अंदाज",
  "Bottlenecks": "अडथळे",
  "Avg Density": "सरासरी घनता",

  "LIVE CROWD RISK ASSESSMENT — 14:33 IST": "थेट गर्दी जोखीम मूल्यांकन — 14:33 IST",
  "/ 10.0 Crowd Risk Index": "/ 10.0 गर्दी जोखीम निर्देशांक",
  "ELEVATED — Pre-peak conditions · Ramkund critical": "वाढलेला — पीक-पूर्व परिस्थिती · रामकुंड गंभीर",

  "Density Risk": "घनता जोखीम",
  "Velocity": "वेग",
  "Pressure": "दाब",
  "Turbulence": "अशांतता",
  "Exit Coverage": "निर्गम व्याप्ती",
  "Response Ready": "प्रतिसाद सज्जता",
  "GOOD": "चांगले",
  "9.2/m² at Ramkund": "रामकुंड येथे 9.2/m²",
  "0.4 m/min — slow flow": "0.4 मी/मिनिट — संथ प्रवाह",
  "Surge from Entry 2": "प्रवेशद्वार 2 पासून वाढ",
  "Movement chaos 56%": "हालचाल अव्यवस्था 56%",
  "3 gates net +ve": "3 प्रवेशद्वार निव्वळ +ve",
  "All units deployed": "सर्व तुकड्या तैनात",

  "Stampede Risk Factor Gauges": "चेंगराचेंगरी जोखीम घटक गेज",
  "Crowd Density": "गर्दी घनता",
  "Flow Velocity": "प्रवाह वेग",
  "Pressure Index": "दाब निर्देशांक",
  "Bottleneck Count": "अडथळा संख्या",
  "Exit Deficit": "निर्गम तूट",
  "persons/100m²": "व्यक्ती/100m²",
  "m/min avg": "मी/मिनिट सरासरी",
  "composite": "संयुक्त",
  "movement chaos": "हालचाल अव्यवस्था",
  "active points": "सक्रिय ठिकाणे",
  "gates > inflow": "प्रवेशद्वार > प्रवाह",

  "Live Crowd Density Map": "थेट गर्दी घनता नकाशा",
  "Real-time zone load · heatmap overlay · bottleneck markers": "रिअल-टाइम झोन भार · हीटमॅप ओव्हरले · अडथळा चिन्हक",
  "Critical >85%": "गंभीर >85%",
  "High 70–85%": "उच्च 70–85%",
  "Moderate 50–70%": "मध्यम 50–70%",
  "Normal <50%": "सामान्य <50%",
  "Updated 14:33": "अद्ययावत 14:33",

  "Zone Status": "झोन स्थिती",
  "Detail": "तपशील",
  "Density": "घनता",
  "Capacity": "क्षमता",
  "Trend": "कल",
  "Click zone again to collapse": "झोन पुन्हा क्लिक करून बंद करा",

  "Crowd Flow — Actual vs Predicted (Today)": "गर्दी प्रवाह — प्रत्यक्ष वि. अंदाजित (आज)",
  "AI 95% prediction band · risk index overlay · full day Simhastha forecast": "एआय 95% अंदाज पट्टा · जोखीम निर्देशांक ओव्हरले · संपूर्ण दिवसाचा सिंहस्थ अंदाज",
  "AI Predicted": "एआय अंदाजित",
  "Current": "सद्य",
  "Peak Est.": "पीक अंदाज",
  "Peak Time": "पीक वेळ",
  "Peak Risk": "पीक जोखीम",

  "4-Hour Predictive Window — P25 / P50 / P75 Forecast": "4-तास पूर्वानुमान विंडो — P25 / P50 / P75 अंदाज",
  "Probabilistic crowd count bands with 30-min intervals · AI Monte Carlo simulation": "30-मिनिट अंतराने संभाव्यता गर्दी संख्या पट्टे · एआय मॉन्टे कार्लो सिम्युलेशन",
  "P75 (high)": "P75 (उच्च)",
  "P50 (median)": "P50 (मध्यक)",
  "P25 (low)": "P25 (कमी)",
  "P75 scenario at 16:00 reaches 8,30,000 pilgrims — Risk Index 7.2. Pre-positioning of additional 200 police recommended by 15:30.":
    "16:00 वाजता P75 परिस्थितीत 8,30,000 यात्रेकरूंपर्यंत पोहोच — जोखीम निर्देशांक 7.2. 15:30 पर्यंत अतिरिक्त 200 पोलिसांच्या पूर्व-तैनातीची शिफारस.",

  "AI Bottleneck Prediction Engine": "एआय अडथळा अंदाज इंजिन",
  "Predicted congestion points, ETA, density, velocity and recommended action": "अंदाजित गर्दी ठिकाणे, अंदाजित वेळ, घनता, वेग आणि शिफारस केलेली कृती",
  "Ramkund Entry 2 — archway": "रामकुंड प्रवेशद्वार 2 — कमान",
  "Godavari Bridge South": "गोदावरी पूल दक्षिण",
  "Panchvati Ghat Steps": "पंचवटी घाट पायऱ्या",
  "Kalaram Temple Queue": "काळाराम मंदिर रांग",
  "Trimbak Bus Stand Exit": "त्र्यंबक बस स्थानक निर्गम",
  "Active diversion in progress": "सक्रिय वळण प्रगतीपथावर",
  "Police deployment recommended": "पोलीस तैनातीची शिफारस",
  "Crowd pacing announcements active": "गर्दी गती नियंत्रण घोषणा सक्रिय",
  "Monitoring — advisory issued": "निरीक्षण — सूचना जारी",
  "No action required": "कोणतीही कृती आवश्यक नाही",
  "Now": "आता",
  "Risk Score": "जोखीम गुण",
  "risk": "जोखीम",

  "Entry / Exit Gate Flow Monitor": "प्रवेश / निर्गम प्रवेशद्वार प्रवाह मॉनिटर",
  "Per-gate inflow, outflow and net crowd balance · gates with positive net require attention": "प्रत्येक प्रवेशद्वारावरील प्रवाह, बाह्यप्रवाह आणि निव्वळ गर्दी संतुलन · सकारात्मक निव्वळ असलेल्या प्रवेशद्वारांकडे लक्ष आवश्यक",
  "Gate": "प्रवेशद्वार",
  "Entry / hr": "प्रवेश / तास",
  "Exit / hr": "निर्गम / तास",
  "Net Flow": "निव्वळ प्रवाह",
  "Load": "भार",

  "Gate 1 — Ramkund Main": "प्रवेशद्वार 1 — रामकुंड मुख्य",
  "Gate 2 — Ramkund Alt": "प्रवेशद्वार 2 — रामकुंड पर्यायी",
  "Gate 3 — Panchvati North": "प्रवेशद्वार 3 — पंचवटी उत्तर",
  "Gate 4 — Panchvati South": "प्रवेशद्वार 4 — पंचवटी दक्षिण",
  "Gate 5 — Trimbak Rd": "प्रवेशद्वार 5 — त्र्यंबक रोड",
  "Gate 6 — Nashik Rd Stn": "प्रवेशद्वार 6 — नाशिक रोड स्थानक",
  "Gate 7 — Kalaram Templ": "प्रवेशद्वार 7 — काळाराम मंदिर",
  "Gate 8 — Gangapur Camp": "प्रवेशद्वार 8 — गंगापूर कॅम्प",
  "Entry/hr": "प्रवेश/तास",
  "Exit/hr": "निर्गम/तास",

  "Crowd Flow Velocity Monitor": "गर्दी प्रवाह वेग मॉनिटर",
  "Average movement speed (m/min) per zone — low velocity = compression risk": "प्रत्येक झोनमधील सरासरी हालचाल गती (मी/मिनिट) — कमी वेग = दाब जोखीम",
  "Ramkund": "रामकुंड",
  "Trimbak": "त्र्यंबक",
  "Nashik Rd": "नाशिक रोड",
  "Ramkund 0.4 m/min — critically slow flow. Stampede risk threshold is <0.5 m/min.": "रामकुंड 0.4 मी/मिनिट — गंभीरपणे संथ प्रवाह. चेंगराचेंगरी जोखीम मर्यादा <0.5 मी/मिनिट आहे.",

  "Multi-Dimensional Zone Risk Radar": "बहु-आयामी झोन जोखीम रडार",
  "Density · velocity · pressure · turbulence · exit flow per selected zone": "निवडलेल्या झोनमधील घनता · वेग · दाब · अशांतता · निर्गम प्रवाह",
  "Kalaram": "काळाराम",
  "Gangapur": "गंगापूर",
  "Exit Gap": "निर्गम तफावत",
  "Higher = higher risk in that dimension ·": "जास्त = त्या मितीमध्ये जास्त जोखीम ·",

  "Crowd Density Heatmap — Zone × Hour": "गर्दी घनता हीटमॅप — झोन × तास",
  "Load % per zone per hour · red = critical overload · green = safe capacity": "प्रत्येक झोन प्रति तास भार % · लाल = गंभीर ओव्हरलोड · हिरवा = सुरक्षित क्षमता",
  "Hour": "तास",

  "Route Saturation — Entry / Exit Corridors": "मार्ग संपृक्तता — प्रवेश / निर्गम मार्गिका",
  "Crowd load on key pilgrimage corridors · evacuation pressure": "प्रमुख यात्रा मार्गिकांवरील गर्दी भार · स्थलांतर दाब",
  "Consider alternate route advisory": "पर्यायी मार्ग सूचनेचा विचार करा",

  "Historical Peak Comparison": "ऐतिहासिक पीक तुलना",
  "Today vs previous Kumbh events — crowd peak and incident count": "आज वि. मागील कुंभ कार्यक्रम — गर्दी पीक आणि घटना संख्या",
  "Nashik Kumbh 2015 — Snan 1": "नाशिक कुंभ 2015 — स्नान 1",
  "Ujjain Simhastha 2016": "उज्जैन सिंहस्थ 2016",
  "Nashik Kumbh 2015 — Snan 2": "नाशिक कुंभ 2015 — स्नान 2",
  "Trimbak Snan 2015": "त्र्यंबक स्नान 2015",
  "Today — Simhastha 2027": "आज — सिंहस्थ 2027",
  "Peak Crowd": "पीक गर्दी",
  "Today's peak estimate (8,10,000) is 26% lower than 2015 Snan 1 peak — improved crowd management effectiveness.":
    "आजचा पीक अंदाज (8,10,000) 2015 स्नान 1 पीकपेक्षा 26% कमी आहे — सुधारित गर्दी व्यवस्थापन परिणामकारकता.",

  "Crowd Composition Analysis": "गर्दी रचना विश्लेषण",
  "Pilgrim demographic mix — informs medical, mobility and accessibility planning": "यात्रेकरू लोकसंख्याशास्त्रीय मिश्रण — वैद्यकीय, गतिशीलता आणि सुलभता नियोजनासाठी उपयुक्त",
  "Senior Citizens (60+)": "ज्येष्ठ नागरिक (60+)",
  "Families w/ children": "मुलांसह कुटुंबे",
  "Adult pilgrims": "प्रौढ यात्रेकरू",
  "Differently abled": "दिव्यांग",
  "VIP / Media": "व्हीआयपी / माध्यम",
  "18% senior citizens + 4% differently abled = high vulnerability cohort. Priority lanes and wheelchair routes activated.":
    "18% ज्येष्ठ नागरिक + 4% दिव्यांग = उच्च असुरक्षित गट. प्राधान्य मार्गिका आणि व्हीलचेअर मार्ग सक्रिय.",

  "AI Crowd Intervention Recommendations": "एआय गर्दी हस्तक्षेप शिफारसी",
  "AI-generated actions ranked by priority · human approval required for execution": "प्राधान्यानुसार क्रमवारी लावलेल्या एआय-निर्मित कृती · अंमलबजावणीसाठी मानवी मंजुरी आवश्यक",
  "Divert Gate 2 overflow → Gate 4 via Godavari Bridge Road": "प्रवेशद्वार 2 चा ओव्हरफ्लो गोदावरी पूल रोडमार्गे प्रवेशद्वार 4 कडे वळवा",
  "Open Camp Delta — Nashik Road shelter overflow": "कॅम्प डेल्टा उघडा — नाशिक रोड निवारा ओव्हरफ्लो",
  "Deploy 2 MSRTC buses — Trimbak Road → Nashik Road Stn": "2 MSRTC बस तैनात करा — त्र्यंबक रोड → नाशिक रोड स्थानक",
  "Activate ORS stations at Panchvati Ghat Steps": "पंचवटी घाट पायऱ्यांवर ORS केंद्रे सक्रिय करा",
  "Broadcast Marathi crowd guidance — Ramkund east entrance": "मराठी गर्दी मार्गदर्शन प्रसारित करा — रामकुंड पूर्व प्रवेशद्वार",
  "Move medical team to Godavari Bridge South pre-position": "वैद्यकीय पथकाला गोदावरी पूल दक्षिण येथे पूर्व-स्थान द्या",
  "Human-in-loop: All P1/P2 actions require officer approval before execution. AI cannot autonomously enforce.":
    "मानवी सहभाग: सर्व P1/P2 कृतींसाठी अंमलबजावणीपूर्वी अधिकाऱ्याची मंजुरी आवश्यक. एआय स्वायत्तपणे अंमलबजावणी करू शकत नाही.",
};

export default shard2;
